import o from "embla-carousel-react";
const r = o;
export { r as useCarousel };